module.exports = __webpack_public_path__ + "img/logo_ppnea.c2a016c9.jpg";